<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Vendeurs</h1>
    </div>

    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h3 class="card-title fw-bold mb-0">Liste des Vendeurs</h3>
        <button class="btn btn-outline-success btn-sm" @click="showCreateSellerModal">
          <i class="fe fe-plus-circle me-1"></i> Ajouter
        </button>
      </div>

      <div class="card-body">
        <TableWithFilters
            :columns="columns"
            :filterableFields="filterableFields"
            :row-actions="rowActions"
            :items="sellers"
            @edit="onEdit"
            @delete="onDelete"
        />
      </div>
    </div>

    <modal-create-seller :seller="selectedSeller" @refresh="loadSellers" />
  </div>
</template>

<script>
  import ModalCreateSeller from "../../../components/modals/ModalCreateSeller.vue";
  import TableWithFilters from "../../../components/TableWithFilters.vue";

  export default {
    name: "Sellers",
    components: {
      TableWithFilters,
      ModalCreateSeller,
    },
    data() {
      return {
        sellers: [],
        selectedSeller: null,
        columns: [
          { key: "firstname", label: "Prénom" },
          { key: "lastname", label: "Nom" },
          { key: "email", label: "Email" },
          { key: "address", label: "Adresse" },
        ],
        filterableFields: ["firstname", "lastname", "email"],
        rowActions: [
          { name: "edit", icon: "fe fe-edit text-primary", event: "edit" },
          { name: "delete", icon: "fe fe-trash text-danger", event: "delete" },
        ],
      };
    },
    methods: {
      showCreateSellerModal() {
        this.selectedSeller = null;
        $('#modal-create-seller').modal('show');
      },
      loadSellers() {
        this.$loading(true);
        this.$http
            .get("/registry/sellers")
            .then(({ data }) => (this.sellers = data))
            .catch((err) => {
              console.error("Erreur chargement vendeurs :", err);
            })
            .finally(() => this.$loading(false));
      },
      onEdit(item) {
        this.selectedSeller = { ...item };
        $('#modal-create-seller').modal('show');
      },
      onDelete(item) {
        this.$swal({
          title: 'Confirmation',
          text: `Voulez-vous supprimer le vendeur "${item.firstname} ${item.lastname}" ?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Oui, supprimer',
          cancelButtonText: 'Annuler',
        }).then((result) => {
          if (result.isConfirmed) {
            this.$loading(true);
            this.$http
                .delete(`/registry/sellers/${item.id}`)
                .then(() => {
                  this.loadSellers();
                  this.$swal("Succès", "Vendeur supprimé avec succès", "success");
                })
                .catch((err) => {
                  console.error("Erreur suppression vendeur :", err);
                  showValidationErrors(err);
                })
                .finally(() => this.$loading(false));
          }
        });
      },
    },
    mounted() {
      this.loadSellers();
    },
  };
</script>
